import type { ProductInfoFormValues } from "../components/productFormSchema"

import type { Product } from "@/graphql/codegen/graphql"

export const convertToProductInfoFormValues = (product: Product): ProductInfoFormValues => ({
  companyId: product.company?.companyId ?? "",
  vendorSku: product.vendorSku ?? "",
  vendorDescription: product.vendorDescription ?? "",
  companyProductDescription: product.companyProductDescription ?? "",
  locationsAssociations: (product.locationsAssociations ?? []).map((locationAssociation) => ({
    address1: locationAssociation.shipping?.address1 ?? "",
    city: locationAssociation.shipping?.city ?? "",
    regionIsoCode: locationAssociation.shipping?.regionIsoCode ?? "",
    locationAssociationId: locationAssociation.locationAssociationId ?? "",
  })),
})
